import { IHttpResponse, IHttpService, IPromise, IQService, ILocationService } from 'angular';
import HttpService from '../http.service';
import SecuredStorage from '../local-storage/secured-storage.service';
import TerritoryService from '../territory.service';
import UtilService from '../util.service';
import { UserResponse } from './user.model';
import { EulaModel, MobileContractDto } from './eula.model';

const territoryCodeKey = 'user-territoryCode';
/* @ngInject */
export default class UserService {
  private userConfig;
  private authPromise: IPromise<boolean>;
  private userResponse: UserResponse;

  eulaTextUrl: any;
  constructor(
    private $http: IHttpService,
    private $q: IQService,
    private $state,
    private $location: ILocationService,
    private config,
    private i18n,
    private httpService: HttpService,
    private territory: TerritoryService,
    private securedStorage: SecuredStorage
  ) {
    this.userConfig = this.config.api.user;
  }

  public isAuthenticated(): IPromise<boolean> {
    if (this.authPromise) {
      return this.authPromise;
    }
    this.authPromise = this.httpService.getResultFromCache('isLoggedIn', this.userConfig.isLoggedIn.url)
      .then(responseData => {
        // this function interrupting redirect to login component and redirect to account.fizy.com to login
        // redirectUrl for login app is taken form config "loginResource" parameter
        // ToDo should remove old logic for login after release. Needs refactoring
        if (responseData) {
          if (!!this.securedStorage.get("currentRedirectURL") && this.securedStorage.get("currentRedirectURL").includes(".fizy.com")) {
            const redirectURL = this.securedStorage.get("currentRedirectURL");
            this.securedStorage.remove("currentRedirectURL");
            window.location.href = redirectURL;
          } else {
            return responseData;
          }
        }


        if (!this.config.auth.useLegacyLogin) {
          var lang = this.$location.search().language;
          if (!lang) {
            lang = this.i18n.getCurrentLanguage();
          } else {
            this.i18n.useLanguage(lang);
          }

          if (window.location.href.indexOf("/buy/") === -1 && window.location.href.indexOf("/offers") === -1) {
            this.redirectToLogin();
          }
        }
      });
    this.authPromise.finally(() => {
      this.authPromise = null;
    });
    return this.authPromise;
  }

  public redirectToLogin() {
    if (!this.config.auth.useLegacyLogin) {
      var lang = this.$location.search().language;
      if (!lang) {
        lang = this.i18n.getCurrentLanguage();
      } else {
        this.i18n.useLanguage(lang);
      }
      window.location.href = `${this.config.auth.loginResource}/login?language=` + lang + `&redirectUrl=${window.location.href}`;
    }
  }

  public getUserInfo(): IPromise<UserResponse> {
    if (!!this.userResponse) {
      return this.$q.resolve(this.userResponse);
    } else {
      return this.httpService
        .getResultFromCache('userInfo', this.userConfig.info.url)
        .then(response => {
          this.userResponse = response;
          return response;
        });
    }
  }

  /**
   * This method check if user from Turkey
   * @returns {angular.IPromise<boolean>}
   */
  public isLocalUserPromise(): IPromise<boolean> {
    return this.getUserInfo().then(info => {
      return (
        this.territory.getAvailableTerritories().indexOf(info.countryISO2) > -1
      );
    });
  }

  /**
   * This method used for check visibility of some menu items when user not from Turkey
   * @returns {angular.IPromise<void>}
   */
  public isNotVisibleForGlobalUser(): IPromise<void> {
    return this.isLocalUserPromise().then(isLocalUser => {
      return isLocalUser ? this.$q.resolve() : this.$state.go('explore');
    });
  }

  public isLocalUser(): boolean {
    return (
      this.territory.getAvailableTerritories().indexOf(this.getTerritory()) > -1
    );
  }

  public getTerritory(): string {
    return this.securedStorage.get(territoryCodeKey) || 'TR';
  }

  public setTerritory(territoryCode: string) {
    this.securedStorage.set(territoryCodeKey, territoryCode);
    // TODO: Fire TerritoryChangeAction.
  }

  public isTurkcellSubscriber(): boolean {
    return this.userResponse && this.userResponse.turkcellSubscriber;
  }

  public resetCache() {
    this.userResponse = null;
  }

  public getEulaUrl(): IPromise<EulaModel> {
    return this.httpService.extractResponseResult(
      this.$http.get(`hafifmuzik/mobile/user/geteulaurl`)
    );
  }

  public moiApprove(): IPromise<boolean> {
    return this.httpService.extractResponseResult(
      this.$http.post(`hafifmuzik/mobile/user/moi/approve`, {})
    );
  }

  public getSubscriptionAvailabilty(): IPromise<MobileContractDto> {
    return this.httpService.extractResponseResult(
      this.$http.get(`hafifmuzik/mobile/user/getSubscriptionAvailabilty`)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/user/user.service.ts